import { createContext } from "react";

let cnx = createContext();

export default cnx;